import React from 'react';
import ReactDOM from 'react-dom';
import './config/i18n';
import TagManager from 'react-gtm-module';
import LogRocket from 'logrocket';
import Cookies from 'js-cookie';
import { identifyLogRocket, USER_ACCESS_COOKIE } from '@plataforma/utils';
import App from './App';
import * as serviceWorker from './serviceWorker';

const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';
const accessInfo = Cookies.getJSON(USER_ACCESS_COOKIE) || {};
const { token } = accessInfo || null;

if (isProd) {
  LogRocket.init(process.env.REACT_APP_LOGROCKET_KEY, {
    rootHostname: process.env.REACT_APP_DOMAIN,
    network: {
      requestSanitizer: request => {
        request.headers.Authorization = null;

        // if it's an authentication url, we don't record the sensitive data
        if (request.url.toLowerCase().indexOf('auth') !== -1) {
          // hide the request head and body
          return null;
        }

        return request;
      }
    }
  });

  if (token) {
    identifyLogRocket();
  }
}

const TMArgs = {
  gtmId: process.env.REACT_APP_GTM_KEY
};

TagManager.initialize(TMArgs);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
